// gift-after-discount.js — Ajoute/retire le cadeau si le SOUS-TOTAL AVANT REMISE >= 84,29 €
// + Re-valide au clic "Checkout" AVANT la redirection
// + Rafraîchit le drawer via cart:refresh + Section Rendering API (IDs réels)

(() => {
// --- Kill-switch contrôlé par l'éditeur de thème (data-gift-enabled="true")
const drawerEl = document.querySelector('cart-drawer');
const GIFT_ENABLED = !!drawerEl && drawerEl.dataset.giftEnabled === 'true';
if (!GIFT_ENABLED) { 
  // Rien à faire : on sort avant de brancher les listeners
  return;
}
  const GIFT_VARIANT_ID = 52596432830728; 
  const THRESHOLD_BEFORE_CENTS = 8429;    

  // ---- Ajax helpers ----
  const ROOT    = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const HEADERS = { 'Content-Type':'application/json', 'Accept':'application/json' };

  const cartGet  = () => fetch(ROOT + 'cart.js', { credentials:'same-origin' }).then(r => r.json());

  const cartAdd  = () => fetch(ROOT + 'cart/add.js', {
    method:'POST', headers:HEADERS, credentials:'same-origin',
    body: JSON.stringify({
      items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _gift: 'Octobre Rose' } }]
  })
});

  const cartSetQ = (key, qty) => fetch(ROOT + 'cart/change.js', {
    method:'POST', headers:HEADERS, credentials:'same-origin',
    body: JSON.stringify({ id:key, quantity:qty })
  });

    // ---- Refresh du drawer (Section Rendering API)
  const getDrawerSectionIds = () => {
    const ids = [];
    const drawer = document.querySelector('cart-drawer');
    const sid = drawer?.dataset?.sectionId;
    if (sid) ids.push(sid);
    if (document.getElementById('shopify-section-cart-icon-bubble') ||
        document.querySelector('[data-section-id="cart-icon-bubble"]')) {
      ids.push('cart-icon-bubble');
    }
    return ids;
  };

  async function refreshDrawer(){
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    const ids = getDrawerSectionIds();
    if (!ids.length) return;
    try{
      const res = await fetch(`${ROOT}?sections=${ids.join(',')}`, { credentials:'same-origin' });
      if (res.ok) {
        const html = await res.json();
        ids.forEach(id => {
          const el = document.getElementById('shopify-section-' + id) ||
                     document.querySelector(`[data-section-id="${id}"]`);
          if (el && html[id]) el.innerHTML = html[id];
        });
      }
    } catch {}
  }

  // ---- Logic ----
  const isGiftLine = (li) =>
    li.id === GIFT_VARIANT_ID && li.properties && (li.properties._gift || li.properties.promo);

  function subtotalBefore(cart){
    // somme des final_line_price des lignes physiques hors cadeau
    return (cart.items || []).reduce((sum, li) => {
      if (!li.requires_shipping) return sum;
      if (isGiftLine(li)) return sum;

      // Avant remises: original_line_price si dispo, sinon price * quantity
      const before = (typeof li.original_line_price === 'number')
        ? li.original_line_price
        : ((li.price || 0) * (li.quantity || 1));

      return sum + before;
    }, 0);
  }

  let busy = false;
  async function ensureGiftOnce() {
    if (busy) return; busy = true;
    try {
      const cart = await cartGet();
      const shouldHave = subtotalBefore(cart) >= THRESHOLD_BEFORE_CENTS;
      const giftLines = (cart.items || []).filter(isGiftLine);

      let changed = false;
      if (shouldHave) {
        if (!giftLines.length) { await cartAdd(); changed = true; }
        else {
          // normaliser: 1 seule ligne, quantité 1
          for (let i = 1; i < giftLines.length; i++) { await cartSetQ(giftLines[i].key, 0); changed = true; }
          if (giftLines[0].quantity !== 1) { await cartSetQ(giftLines[0].key, 1); changed = true; }
        }
      } else {
        for (const g of giftLines) { await cartSetQ(g.key, 0); changed = true; }
      }

      if (changed) await refreshDrawer();
    } catch (e) {
      console.warn('[gift] error', e);
    } finally { busy = false; }
  }

  // Intercepter le clic "Checkout" pour garantir l’état du cadeau AVANT la sortie
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!btn) return;
    // On ne s’applique qu’à l’intérieur du drawer
    if (!btn.closest('#mini-cart, cart-drawer')) return;
    e.preventDefault();
    try { await ensureGiftOnce(); } catch {}
    window.location.assign(ROOT + 'checkout');
  });

  // Déclencheurs
  document.addEventListener('DOMContentLoaded', ensureGiftOnce);

  const _fetch = window.fetch;
  window.fetch = async function(...args){
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && url.includes('/cart/')) setTimeout(ensureGiftOnce, 0);
    } catch {}
    return res;
  };
  document.addEventListener('cart:updated', ensureGiftOnce);
  document.addEventListener('ajaxCart:requestComplete', ensureGiftOnce);
  document.documentElement.addEventListener('cart:refresh', ensureGiftOnce);
})();
